@include section-styles(0px, 0px);

section {
  &.vh-100 {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.wrapper {
  width: 100%;
  margin: 0 auto;

  &.position-center {
    max-width: 900px;
  }
}

@include media-min-width($breakpoint-m) {
  .wrapper {
      width: 750px;
  }
}

@include media-min-width($breakpoint-l-deprecated) {
  .wrapper {
      width: 970px;
  }
}

@include media-min-width($breakpoint-xl) {
  .wrapper {
      width: 1170px;
  }
}

p, h1, h2, h3, h4 {
  @include text-main;
  color: var(--color-dark-grey);
  width: 100%;
  margin: 0;
}

h1, h2, h3, h4 {
  @include text-bold;
}

.inner {
    margin: 1rem auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    align-self: center;
    width: 100%;
    flex-direction: column;
    padding: 0 15px;
}

.text-position-left {
    text-align: left;
}

.text-position-center {
    text-align: center;
}

.text-position-right {
    text-align: right;
}

$max: 128;

@for $i from 10 through $max {
    .text-#{$i} {
        font-size: $i + px;
    }

    @include media-max-width($breakpoint-l) {
        .text-#{$i} {
            font-size: ($i * 0.8) + px;
        }
    }

    @include media-max-width($breakpoint-m) {
        .text-#{$i} {
            font-size: ($i * 0.4) + px;
        }
    }
}
